import { render, staticRenderFns } from "./CcmAssessment.vue?vue&type=template&id=5480d4ba&scoped=true&"
import script from "./CcmAssessment.vue?vue&type=script&lang=js&"
export * from "./CcmAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5480d4ba",
  null
  
)

export default component.exports